export const GameBadgeEnum = {
    0: 'none',
    1: 'top',
    2: 'hot',
    3: 'jackpot',
    4: 'new',
    5: 'soon',
    6: 'premium',
    7: 'popular',
    8: 'trending',
    9: 'cashback',
    10: 'bonus',
    11: 'promotion',
    12: 'exclusive',
    13: 'tournament'
}